import { render } from "./DuplicateOptionModal.vue?vue&type=template&id=2218cf79&scoped=true"
import script from "./DuplicateOptionModal.vue?vue&type=script&lang=js"
export * from "./DuplicateOptionModal.vue?vue&type=script&lang=js"

import "./DuplicateOptionModal.vue?vue&type=style&index=0&id=2218cf79&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2218cf79"]])

export default __exports__